export const ASSETS = {
  logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_prospecter-academy/artifacts/rap9v4sl_IMG-20260822-WA0003.jpg",
  bookLake:
    "https://customer-assets.emergentagent.com/job_49045abd-72fc-4b8d-b96a-ed0282a1e4cb/artifacts/f1jhlov0_file_00000000684472438f747d8bf9966b46.png",
  bookVertical:
    "https://customer-assets.emergentagent.com/job_49045abd-72fc-4b8d-b96a-ed0282a1e4cb/artifacts/h3f3v3qt_file_00000000da747243ab17a98db30581c4.png",
  coachPortrait:
    "https://customer-assets.emergentagent.com/job_49045abd-72fc-4b8d-b96a-ed0282a1e4cb/artifacts/ogzs05v1_file_00000000d8a87243b5936ea1780738b7.png",
  coachWithBook:
    "https://customer-assets.emergentagent.com/job_49045abd-72fc-4b8d-b96a-ed0282a1e4cb/artifacts/4a66s2ko_file_00000000703c72438af21fff6f7fbb4d.png",
  // Conference photos (Roméo on stage & audience)
  confPointing:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_prospecter-academy/artifacts/gl61ibkw_IMG-20260901-WA0138.jpg",
  confAudienceWide:
    "https://customer-assets.emergentagent.com/job_prospecter-academy/artifacts/vndw9nyy_a7ae2f98343640cc84af19be45bb324d.webp",
  confAudience2:
    "https://customer-assets.emergentagent.com/job_prospecter-academy/artifacts/667psfbm_24c5f31bd61c4522bbf0ade3c5045d93.webp",
  confHandshake:
    "https://customer-assets.emergentagent.com/job_prospecter-academy/artifacts/m5j4a14r_bb0999b7ca684e138ec6e70891426832.jpg",
  confCrowdStanding:
    "https://customer-assets.emergentagent.com/job_prospecter-academy/artifacts/fzfn03f7_16708871db104b1299eaa7c7b711d7a5.jpg",
  confRomeoStage:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_prospecter-academy/artifacts/p06pxlw4_IMG-20260901-WA0126.jpg",
  confBackAudience:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_prospecter-academy/artifacts/8qcab8wy_IMG-20260901-WA0135.jpg",
};

export const CHARIOW_URL = "https://ipmagjos.mychariow.shop/prd_ezeac0/checkout";
export const WHATSAPP_COMMUNITY = "https://chat.whatsapp.com/BidqmxjGn7v4xL7nFuDjnK";
export const COACH_WHATSAPP = "14386866769";
export const SUPPORT_EMAIL = "support@prospectheure.com";
